export const tableHeader = [
  'Title',
  'Description',
  'Material Type',
  'Order',
  'Status',
  'Action'
]

export const materialType = [
  {
    id: 'text',
    name: 'Text'
  },
  {
    id: 'image',
    name: 'Image'
  },
  {
    id: 'snyposis',
    name: 'Synposis'
  },
  {
    id: 'video',
    name: 'Video'
  }
]
